//import liraries
import moment from "moment";
import React, { Component } from "react";
import { View, Text, StyleSheet } from "react-native";
import CTiCertificateWrapper from "../../../common/CTiCertificateWrapper";
import CText from "../../../common/CText";

// create a component
const TiCertificateCard = (props) => {

  let policyData=props?.data?.policyData
  console.log(props,"props00000")

  let sumAssured = "N/A";
  let policyNumber = "N/A";
  let policyType = "N/A";
  let expiryDate = "N/A";
  let startDate = "N/A";
  let status = "Opted";
  if (policyData && policyData.activePolicy) {
    sumAssured = policyData.activePolicy?.sumAssured;
    policyNumber = policyData.activePolicy?.coiNo;
    policyType = policyData.activePolicy?.planName;
    const expiryDateNF = policyData.activePolicy?.expiryDate;
    if (expiryDateNF) {
      expiryDate = moment(expiryDateNF, "DDMMYYYYHHmmss").format("DD/MM/YYYY");
    }
    const startDateNF = policyData.activePolicy?.policyStartDt;
    if (startDateNF) {
      startDate = moment(startDateNF, "DDMMYYYYHHmmss").format("DD/MM/YYYY");
    }
    status = "Active";
  } else if (policyData && policyData.recurringPolicyOpted) {
    sumAssured = policyData.recurringPolicyOpted?.sumAssured;
    policyType = policyData.recurringPolicyOpted?.planName;
    const startDateNF = policyData.recurringPolicyOpted?.optInDt;
    if (startDateNF) {
      startDate = moment(startDateNF, "DDMMYYYYHHmmss").format("DD/MM/YYYY");
    }
  }

  return (
    <View style={[styles.container,{borderColor:props.borderColor,borderWidth:props.borderWidth}]}>
      <CText.certificateHeadlineText
        style={{ marginLeft:25, marginTop: 30 }}
      >
        {"Insurance Details"}
      </CText.certificateHeadlineText>
      <View style={{ marginTop: 15 }}>
        <CTiCertificateWrapper
          keyText={"Policy number"}
          valueText={policyNumber}
        />
        <CTiCertificateWrapper
          keyText={"Plan name"}
          valueText={policyType}
        />
        <CTiCertificateWrapper
          keyText={"Plan term"}
          valueText={policyType}
        />
        <CTiCertificateWrapper
          keyText={"Amount"}
          valueText={sumAssured}
        />
        <CTiCertificateWrapper
          keyText={"Start date"}
          valueText={startDate}
        />
        <CTiCertificateWrapper
          keyText={"Status"}
          valueText={status}
        />
      </View>
    </View>
  );
};

// define your styles
const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: "100%",
    backgroundColor: "#ffffff",
    borderRadius: 15,
  },
});

//make this component available to the app
export default TiCertificateCard;
